import Typography from 'components/Typography';
import { FormattedMessage } from 'react-intl';
import badgeCheckSrc from 'components/icons/badge-check.svg';
import classnames from 'classnames';
import activeProBadgeSrc from '../../../assets/images/icons/cuttlefish/activeProBadge.svg';
import * as styles from './styles/styles.module.scss';

type Feature = {
  text: JSX.Element;
  pro: boolean;
  new?: boolean;
};

type ProFeatureComparisonTableProps = {
  features: Feature[];
  containerStyles?: string;
};

const ProFeatureComparisonTable = ({ features, containerStyles }: ProFeatureComparisonTableProps) => (
  <table className={classnames(styles.features, containerStyles)}>
    <thead>
      <tr>
        <th className={styles.head}>
          <FormattedMessage defaultMessage="FEATURES" />
        </th>
        <th>
          <FormattedMessage defaultMessage="FREE" />
        </th>
        <th>
          <img alt="active badge" src={activeProBadgeSrc} />
        </th>
      </tr>
    </thead>
    <tbody>
      {features.map((feature, index) => (
        <tr key={index} className={styles.feature}>
          <td>
            <Typography variant="subhead2">{feature.text}</Typography>
          </td>
          <td>
            {!feature.pro && <img alt="badge" src={badgeCheckSrc} />}
            {feature.new && (
              <div className={styles.newBadge}>
                <FormattedMessage defaultMessage="New" />
              </div>
            )}
          </td>
          <td>
            <img alt="badge" src={badgeCheckSrc} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export { ProFeatureComparisonTable as default, ProFeatureComparisonTableProps };
